// extracted by mini-css-extract-plugin
module.exports = {"addButton":"Documents_addButton__36W6i","container":"Documents_container__BPxQj"};